import { getCurrencySymbol } from './getCurrencySymbol';

export const convertPriceToStr = (value: number | null | undefined, currencyCode?: string) => {
  if (!value) return '-';
  const absVal = Math.abs(value);
  const currencySymbol = getCurrencySymbol(currencyCode);
  if (absVal >= 10 ** 12) return `${Math.round(value / 10 ** 10) / 100}T${currencySymbol}`;
  if (absVal >= 10 ** 9) return `${Math.round(value / 10 ** 7) / 100}B${currencySymbol}`;
  if (absVal >= 10 ** 6) return `${Math.round(value / 10 ** 4) / 100}M${currencySymbol}`;
  if (absVal >= 10 ** 3) return `${Math.round(value / 10) / 100}K${currencySymbol}`;
  return `${value.toFixed(2)}${currencySymbol}`;
};
